<div class="form-values">
  <vcl-alert
    *ngIf="err_msn"
    class="mt-3"
    [type]="'error'"
    [icon]="'aviso_outline'"
    [dismissible]="false"
  >
    {{ copyService.copies.configuration_values.err_msn
    }}{{ max_value | currency: "CAD":"symbol-narrow": "1.0-0" }}
  </vcl-alert>
  <h2
    class="subtitle"
    [innerHtml]="copyService.copies.configuration_values.Title"
  ></h2>
  <h3>
    {{ copyService.copies.configuration_values.sub_Title_1 }}
    {{ max_value | currency: "CAD":"symbol-narrow" : "1.0-0"  }}
    {{ copyService.copies.configuration_values.sub_Title_2 }}
  </h3>
  <div class="row" id="forms">

    <form class="form" [formGroup]="formValues" class=" label col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" autocomplete="off" *ngIf="state_master">
      <div class="row">
          <vcl-form-field
          label="{{ copyService.copies.configuration_values.label_Master }}"
          label="nome"
          class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
          msgErr="{{ copyService.copies.configuration_values.err_Master }}">
  
            <input
            voxelMask="currency"
            [config]="config"
            vclInput
            placeholder="{{copyService.copies.configuration_values.placeholder_Value}}"
            formControlName="value_master"
            (input)="enableNextButton()"
          />
          </vcl-form-field>
      </div>
      <span class="description">{{ copyService.copies.configuration_values.min_Master }}</span>
  </form>

  <form class="form" [formGroup]="formValues" class="label col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" autocomplete="off" *ngIf="state_visa">
    <div class="row">
        <vcl-form-field 
        label="{{ copyService.copies.configuration_values.label_Visa }}"
        label="nome"
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
        msgErr="{{ copyService.copies.configuration_values.err_Visa }}">
  
          <input
          voxelMask="currency"
          [config]="config"
          vclInput
          placeholder="{{copyService.copies.configuration_values.placeholder_Value}}"
          formControlName="value_visa"
          (input)="enableNextButton()"
        />
        </vcl-form-field>
    </div>
    <span class="description">{{ copyService.copies.configuration_values.min_Visa }}</span>
  </form>

  <form class="form" [formGroup]="formValues" class=" label col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6" autocomplete="off" *ngIf="state_visalf">
    <div class="row">
        <vcl-form-field
        label="{{ copyService.copies.configuration_values.label_Visalf }}"
        label="nome"
        class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
        msgErr="{{ copyService.copies.configuration_values.err_Visalf }}">
  
          <input
          voxelMask="currency"
          [config]="config"
          vclInput
          placeholder="{{copyService.copies.configuration_values.placeholder_Value}}"
          formControlName="value_visalf"
          (input)="enableNextButton()"
        />
        </vcl-form-field>
    </div>
    <span class="description">{{ copyService.copies.configuration_values.min_Visalf }}</span>
  </form>
  </div>



</div>
<app-controls
  id="formGoodsBtns"
  [hasPrevious]="true"
  [nextLabel]="copyService.copies.configuration_values.form_next_button"
  (only_previous)="sendBackButtonEvent()"
  (next)="next()"
  [nextDisabled]="state_next"
></app-controls>
